<template>
  <v-container fluid class="no-border-container" >
    <v-card-text>
      <div class="stock-status">
        <div class="header">
          <button @click="goToStockHome" class="back-button"><i class="fa fa-arrow-left"></i> Back</button>
          <h4>Stock Status</h4>
        </div>

      <div class="cherry-info">
        <p>Cherry ID: 001</p>
        <p>Factory Name: Ritho</p>
        <p>Total Bulked Cherry Weight: 800kg</p>
        <p>Cherry Weight: 800kg</p>
        <p>Percentage Cherry Weight: 37.5%</p>
      </div>
      
      <div class="sections">
        <section v-for="(section, index) in sections" :key="index" class="section">
          <h2 class="cherry-h2">{{ section.title }}</h2>
          <div class="section-details">
            <div v-for="(detail, i) in section.details" :key="i" class="detail">
              <p>{{ detail.label }}: {{ detail.value }}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
</v-card-text>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'growerstockstatusdetail',
    data() {
      return {
        sections: [
          {
            title: "Parchment Outturn: 11MU001",
            details: [
              { label: "Miller Name", value: "Kipkelion" },
              { label: "Miller Code", value: "KK" },
              { label: "Grower Outturn", value: "11MU0001" },
              { label: "Grower Parchment Weight", value: "55KG" },
              { label: "Parchment Grade", value: "P1" },
              { label: "Total Parchment Bulk Weight", value: "55KG" },
              { label: "Parchment Weight Percentage", value: "55%" }
            ]
          },
          {
            title: "Clean Coffee Outturn: 11MU2001",
            details: [
              { label: "Parchment Outturn", value: "11MU2001" },
              { label: "Total Clean Coffee Bulk Weight", value: "100KG" },
              { label: "Clean Coffee Weight", value: "60KG" },
              { label: "Clean Coffee Weight Percentage", value: "60%" },
              { label: "Grower Clean Coffee Weight", value: "33KG" },
              { label: "Clean Grade", value: "AA" }
            ]
          },
          {
            title: "GRN Coffee Details: 11MU2001",
            details: [
              { label: "Warehouse Name", value: "BALORE" },
              { label: "Warehouse Location", value: "Location" },
              { label: "Delivery Date", value: "11/10/2024" },
              { label: "Split 1 Warrant No", value: "WX112" },
              { label: "Split 1 Weight", value: "33KG" },
              { label: "Split 2 Warrant No", value: "WX113" },
              { label: "Split 2 Weight", value: "11KG" }
            ]
          },
          {
            title: "Broker Bulking/Splitting Details: 11232001",
            details: [
              { label: "Broker Name", value: "KCCE" },
              { label: "Lot Number", value: "1234" },
              { label: "Clean Coffee Percentage", value: "56%" },
              { label: "Total Lot Weight", value: "1000KGs" },
              { label: "Reserve Price", value: "$20,000" }
            ]
          },
          {
            title: "Auction Result Details: 11232001",
            details: [
              { label: "Auction Result ID", value: "467" },
              { label: "Buyer Name", value: "Daniel Mzingu" },
              { label: "E-SLIP Number", value: "EXBWS7898" },
              { label: "Sale Date", value: "15th Feb 2024" },
              { label: "Buying Price", value: "$22,000" },
              { label: "Sale Number", value: "5" },
              { label: "Status", value: "Pending Payment" }
            ]
          }
        ]
      };
    },
    methods:{
      goToStockHome() {
      this.$router.push('/grower/stock/');
    }
    }
  };
  </script>
  
  <style scoped>
  .search-section {
    margin: 20px 0;
    padding: 10px;
  }
  
  .search-bar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .search-bar input {
    padding: 5px;
  }
  .table_area_box_empty {
    position: relative;
    background: #fff;
    overflow-x: auto;
    /* //border: 1px solid #707070; */
  }
  
  .table_area_box {
    position: relative;
    background: #fff;
    overflow-x: auto;
  /* //border: 1px solid #707070; */
    
  }
  
  .thead {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }
  
  .table tbody tr > td.actions {
    font-size: 20px !important;
    color: #733D29 !important;
    padding-top: 0px;
  }
  
  .pagination {
    background-color: red;
  }
  
  .paginationtext {
    color: #733D29;
  }
  
  .pagination > li > a,
  .pagination > li > span {
    border: 1px solid #F2D0A7;
    color: #733D29;
  }
  
  .pagination > li.active > .page-link {
    background: #00513B;
    color: #fff;
  }
  
  .table {
    overflow-x: auto;
  }
  
  td {
    max-width: 200px; /* Set a maximum width for cells */
    overflow: hidden;
    text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
    white-space: nowrap; /* Prevent text from wrapping */
  
  }

  /*
  search
  */
  .stock-status {
    padding: 20px;
    background-color: #e3eae8;
    font-family: Arial, sans-serif;
    border-radius: 15px; 
    padding: 10px; 
  }
  .cherry-info {
    display: flex;
    justify-content: space-between;
    background-color: #e9f5f3;
    padding: 10px;
    border: 2px solid #548b54;
    border-radius: 5px;
    margin-bottom: 20px;
  }
  .cherry-h2 {
    display: flex;
    justify-content: space-between;
    background-color: #869a95;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 20px;
  }
  .cherry-info p {
    margin: 0;
  }
  
  .sections {
    display: flex;
    flex-direction: column;
  }
  
  .section {
    background-color: #f0f0f0; 
    margin-bottom: 15px;
    padding: 15px;
    border-radius: 5px;
  }
  
  .section h2 {
    font-size: 20px;
    margin-bottom: 10px;
    background-color:  #ccc;
  }
  
  .section-details {
    display: flex;
    flex-wrap: wrap;
  }
  
  .detail {
    width: 48%;
    margin-bottom: 10px;
  }
  
  .detail p {
    margin: 0;
    font-size: 14px;
  }
  .header {
    display: flex;
    align-items: center;
  }
  
  .back-button {
    background-color: #00513B; /* Dark green */
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 5px; /* Optional: add rounded corners */
    cursor: pointer;
    margin-bottom: 5px;
  }
  
  .back-button:hover {
    background-color: #003d2d; /* Darker green on hover */
  }
  </style>
  